var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner dg-scheme-detail" }, [
    _c("div", { staticClass: "app-main-inner-row" }, [
      _c("div", { staticClass: "filters" }),
      _c(
        "div",
        { staticClass: "triggers" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Add", disabled: _vm.locked, type: "primary" },
              on: { click: _vm.toAdd }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Delete", disabled: _vm.locked, type: "danger" },
              on: { click: _vm.toDelete }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      {
        staticClass: "app-main-inner-row row-grid",
        staticStyle: { "min-height": "400px", padding: "8px 0 0" }
      },
      [
        _c("cargo-ag-grid", {
          attrs: {
            "config-module": "100702",
            "grid-params": _vm.gridParams,
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData
          },
          on: {
            "update:gridParams": function($event) {
              _vm.gridParams = $event
            },
            "update:grid-params": function($event) {
              _vm.gridParams = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }